module.exports = __webpack_public_path__ + "img/887153_E5C188_433729_C1A484-256px.b7cd39f5.png";